import { Component, OnInit, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { Entidad, TipoEntidad } from '../../interfaces/entidad';
import { Pais, Direccion, Provincia } from '../../interfaces/direccion';
import { ListarContactosComponent } from './contactos/listar-contactos/listar-contactos.component';
import { FormControl, Validators, Form } from '@angular/forms';
import { DireccionService } from '../../providers/direccion.service';
import { ContactoService } from '../../providers/contacto.service';
import { EntidadService } from '../../providers/entidad.service';
import { Contacto, TipoContacto } from '../../interfaces/contacto';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { MatSelectChange, MatAutocomplete } from '@angular/material';
import { Telefono } from '../../components/telefono/telefono.component';
import { TipoClienteService } from '../clientes/tipos-cliente/tipo-cliente/tipo-cliente.service';
import { TipoCliente } from '../clientes/tipos-cliente/tipo-cliente/tipo-cliente';
import { ArchivoEntidad } from '../../interfaces/archivo-entidad';
import { FileHolder } from '../../components/archivos/image-upload/image-upload.component';
import { Examen } from '../../interfaces/examen';
import { KitBienvenida } from '../../interfaces/kit-bienvenida';
import { PerfilWeb } from '../../interfaces/perfil-web';
import { TipoPago } from '../../interfaces/tipo-pago';
import { TipoPagoService } from '../../providers/tipo-pago.service';
import { PersonasService } from '../../providers/personas.service';

@Component({
  selector: 'app-entidad',
  templateUrl: './entidad.component.html',
  styleUrls: ['./entidad.component.scss']
})
export class EntidadComponent implements OnInit {
  @Input() IdEntidad?: number | string;
  entidad: Entidad;
  archivoEntiidad: ArchivoEntidad;
  paises: Pais[] = [];
  cargandoPaises: boolean = false;
  provincias: Provincia[] = [];
  examenes: Examen[] = [];
  certificacionesEntrante:  any[] = []; 
  kits: KitBienvenida[] = [];
  perfiles: PerfilWeb[] = [];
  pagos: TipoPago[] = [];
  cargandoProvincias: boolean = false;
  @Output() onEntidadInput = new EventEmitter(); // datos del formulario cambian
  @Output() formState = new EventEmitter(); // emite el estado del formulario
  // listado de contactos
  @ViewChild(ListarContactosComponent) listadoContactos: ListarContactosComponent;
  @ViewChild(MatAutocomplete) provinciaAuto: MatAutocomplete;
  @ViewChild(MatAutocomplete) localidadAuto: MatAutocomplete;
  razonSocialFormControl = new FormControl('', [
    Validators.required
  ]);
  emailFormControl = new FormControl('', [
    Validators.required
  ]);
  cuitFormControl = new FormControl('', [
    Validators.required
  ]);
  provinciaFormControl: FormControl;
  provinciasFiltradas: Observable<any[]>;
  cargandoTiposCliente: boolean;
  tiposCliente: any[] = [];
  tipoClienteSinFiltro: any[] = [];
  Origenes:any;
  imagenProspecto: FormControl;
  archivos = [];
  certificacionesEntranteSinFiltro: any[] = [];
  list_provincias: any[] = [];
  list_localidades: any[] = [];
  list_paises: any[] = [];
  filteredLocalidades = [...this.list_localidades];

  esCliente = false;
  numberOfDays: number[] = Array.from({ length: 31 }, (_, i) => i + 1);
  months: string[] = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];
  constructor(
    private direccionService: DireccionService,
    private entidadService: EntidadService,
    private contactoService: ContactoService,
    private tipoClienteSv: TipoClienteService,
    private pagoService: TipoPagoService,
    private _personasSv: PersonasService, 
  ) {
    // Filtro a medida que van escribiendo una provincia
    this.provinciaFormControl = new FormControl();
    this.provinciasFiltradas = this.provinciaFormControl.valueChanges
      .pipe(
        startWith(''),
        map(provincia => provincia ? this.filtroProvincias(provincia) : this.provincias.slice())
      );
  }

  ngOnInit() {
    
    this.entidadService.getTipoCertificacion().subscribe(
      respuesta => {
        console.log('Aca estan las certificaciones',respuesta);
        this.certificacionesEntranteSinFiltro = respuesta.data.tiposCertificacion;

        
        this.certificacionesEntrante = respuesta.data.tiposCertificacion.filter(certificacion => certificacion.estado == 1);
        // 
      }
    );
    
    this.entidad = new Entidad(); // crear un entidad en blanco
    this.entidadService.getExamen().subscribe(
      respuesta => {
        // console.log('Examen', respuesta);
        this.examenes = respuesta.data.examenes;
      },
    );
    this.entidadService.getKitBienvenida().subscribe(
      respuesta => {
        // console.log('Kit Bienvenida', respuesta);
        this.kits = respuesta.data.kits;
      },
    )
    this.entidadService.getPerfilWeb().subscribe(
      respuesta => {
        // console.log('Perfil Web', respuesta);
        this.perfiles = respuesta.data.perfiles;
        this.Origenes=respuesta.data.origenes;
      },
    )
    this.paises = [];
    this.cargandoPaises = true;
    this.direccionService.getPaises().subscribe(
      respuesta => {
        // console.log('Paises', respuesta);

        if (respuesta.estado == 1 && respuesta.data) {
          respuesta.data.forEach(pais => {
            this.paises.push({
              IdPais: pais.IdPais,
              descripcion: pais.PaisNombre
            });
          });
        }

        this.cargandoPaises = false;
      },
      () => {
        this.cargandoPaises = false;
      }
    );

    this.traerTiposCliente();
    this.traerPagos();
    this.traerProvinciasPorPais();

    if (this.IdEntidad != null) { // si recibo un id solicitar los datos
      this.formState.emit({ cargando: true });
      this.entidadService.getEntidades(
        {
          page: 0,
          pageSize: 200
        },
        {
          sort: null,
          order: null
        },
        {
          IdEntidad: this.IdEntidad
        }
      ).subscribe(
        respuesta => {
          if (respuesta.estado == 1 && respuesta.data) {
            var entidad = respuesta.data.entidades[0];
            if (entidad) {
              this.entidad = new Entidad(
                entidad.id,
                entidad.razonSocial,
                entidad.nombreFantasia,
                entidad.nombre,
                entidad.apellido,
                entidad.cargo,
                entidad.dia_nacimiento,
                entidad.mes_nacimiento,
                entidad.telefonoPrincipal,
                entidad.telefonoPrincipalCodigoPais,
                entidad.telefonoPrincipalCodigoArea,
                entidad.telefonoPrincipalNumero,
                entidad.telefonoMovil,
                entidad.telefonoMovilCodigoPais,
                entidad.telefonoMovilCodigoArea,
                entidad.telefonoMovilNumero,
                entidad.cuit,
                entidad.fechaContacto,
                <Direccion>{
                  codigoPostal: entidad.codPostal,
                  calle: entidad.direccionCalle,
                  departamento: entidad.direccionDepartamento,
                  numero: entidad.direccionNumero,
                  piso: entidad.direccionPiso,
                  localidad: entidad.localidad,
                  pais: {
                    IdPais: entidad.pais.IdPais,
                    descripcion: entidad.pais.descripcion
                  },
                  provincia: entidad.provincia
                },
                entidad.fechaModificacion,
                !!+entidad.VIP,
                <TipoEntidad>{
                  IdTipo: entidad.tipo.IdTipo,
                  descripcion: entidad.tipo.TipoDescripcion
                },
                entidad.idExtranet,
                null,
                entidad.created_by,
                <TipoCliente>{
                  id: entidad.tipoCliente.id,
                  descripcion: entidad.tipoCliente.descripcion
                },
                null,
                null,
                entidad.tipo.IdTipo == '1' ? false : true,
                entidad.observacion,
                entidad.redSocial1,
                entidad.redSocial2,
                entidad.paginaWeb,
                entidad.direccionFacturacion,
                entidad.IdTango,
                entidad.condicionVenta,
                entidad.porcentajeBonificacion,
                entidad.transporte,
                entidad.certificacion,
                entidad.fechaCertificacion,
                entidad.pago,
                entidad.examen,
                entidad.kit,
                entidad.perfil,
                entidad.email,
                {
                  id: entidad.origen.id,
                  descripcion: entidad.origen.descripcion
                }
              );

              this.traerContactos(+this.entidad.IdEntidad); // traer sus contactos
              this.traerProvincias(+this.entidad.direccion.pais.descripcion);

              this.formState.emit({ // datos encontrados
                estado: 1,
                mensaje: respuesta.mensaje,
                cargando: false
              });
              this.seleccionarCertificacion();
              this.seleccionarTipoCliente();
            } else {
              this.formState.emit({ // error al buscar datos
                estado: 3,
                mensaje: 'No se encontraron los datos buscados',
                cargando: false
              });
            }
          }
          
        },
        error => {
          this.formState.emit({ // error con el servidor
            estado: 2,
            mensaje: error,
            cargando: false
          });
        }
      );
    }
  }

  seleccionarCertificacion() {
    let mayus = this.entidad.certificacion;
  
    // Iterar sobre las certificaciones entrantes
    
      this.certificacionesEntranteSinFiltro.forEach(cert => {
        if(mayus != null){
          if (mayus.toUpperCase() === cert.descripcion.toUpperCase()) { // Comparar en mayúsculas
            // console.log('Este es el que llega por entidad', cert.descripcion);
            // Asignar la certificación encontrada a entidad.certificacion
            if(cert.estado == 0){
              this.certificacionesEntrante.push(cert);
            }
            this.entidad.certificacion = cert;
            return; // Salir del forEach cuando se encuentra la coincidencia
          }
        }else{
          return
        }
      });
   

  }
  seleccionarTipoCliente(){
    let mayus = this.entidad.tipoCliente.descripcion;
    console.log('Esta es la entidad completa', this.entidad.tipoCliente.descripcion);

    this.tipoClienteSinFiltro.forEach(cliente => {
    if( mayus != null){
    if (mayus.toUpperCase() === cliente.descripcion.toUpperCase()) { // Comparar en mayúsculas
         console.log('Este es el que llega por entidad', cliente.descripcion);
        
    //     // Asignar la certificación encontrada a entidad.certificacion
        if(cliente.estado == 0){
          this.tiposCliente.push(cliente);
        }
        return; // Salir del forEach cuando se encuentra la coincidencia
      }
    }else{
      return
    }
    });
  }

  onInput(): void { // cuando cambia un dato emitimos un evento
    this.onEntidadInput.emit();
    // console.log('razonsocial', this.razonSocialFormControl.value);
  }
  onSelectionChange(): void {
    // Emitimos el evento cuando cambia la selección
    this.onEntidadInput.emit();
  }

  onPaisChange(event: MatSelectChange): void {
    this.clearProvincia();
    this.traerProvincias(+event.value);
  }
  onClasificacionChange(event: MatSelectChange): void {
    // this.clearProvincia();
    // this.traerProvincias(+event.value);
  }

  onClearPais(event: any): void { // limpiar país seleccionado
    event.stopPropagation(); // porque si no se abre el select
    this.entidad.direccion.pais.descripcion = null; // modificar modelo
    this.clearProvincia();
  }

  clearProvincia(): void {
    // clear provincia
    this.provincias = [];
    this.provinciaFormControl.setValue(null);
    this.provinciaFormControl.updateValueAndValidity();
  }

  filtroProvincias(descripcion: string) {
    return this.provincias.filter(provincia =>
      provincia.descripcion.toLowerCase().indexOf(descripcion.toLowerCase()) === 0);
  }

  compararPorId(dato1: any, dato2: any): boolean | null {
    if (dato1 && dato2) {
      return dato1.id == dato2.id;
    }

    return false;
  }
  traerProvinciasPorPais(): void {
    console.log('Traer Provincias');
    this._personasSv.getCiudadProviciaPais().subscribe(
      respuesta => {
        console.log(respuesta.provincias, "respuesta");
        this.list_provincias = respuesta.provincias;
        console.log(this.list_provincias, "Provincias");
        this.list_localidades = respuesta.localidades;
        console.log(this.list_localidades, "Localidades");
        this.list_paises = respuesta.paises;
      }
    )
  }
  filtrarLocalidades() {
    const input = this.entidad.direccion.localidad.toLowerCase();
    this.filteredLocalidades = this.list_localidades.filter(localidad =>
      localidad.LocalidadNombre.toLowerCase().includes(input)
    );
  }

  traerTiposCliente(): void {
    this.tiposCliente = [];
    this.tipoClienteSinFiltro = [];
    this.cargandoTiposCliente = true;
    this.tipoClienteSv.getTiposCliente().subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.tiposCliente) {
          console.log('Aca esta el tipo de cliente', respuesta.data.tiposCliente);
          this.tiposCliente = respuesta.data.tiposCliente.filter(tipoCliente => tipoCliente.estado == 1);
          this.tipoClienteSinFiltro = respuesta.data.tiposCliente;
        }
      },
      () => {
        this.cargandoTiposCliente = false;
      },
      () => {
        this.cargandoTiposCliente = false;
      }
    );
  }

  traerProvincias(IdPais: number): void {
    if (IdPais) { // si hay un ID
      this.provincias = [];
      this.cargandoProvincias = true;
      this.direccionService.getProvincias(
        IdPais
      ).subscribe(
        respuesta => {
          if (respuesta.estado == 1 && respuesta.data) {
            respuesta.data.forEach(provincia => {
              this.provincias.push(new Provincia(
                provincia.IdProvincia,
                provincia.ProvinciaNombre
              ));
            });

            this.provinciaFormControl.updateValueAndValidity();
            this.cargandoProvincias = false;
          }
        },
        () => {
          this.cargandoProvincias = false;
        }
      );
    }
  }

  traerContactos(IdEntidad: number): void {
    if (IdEntidad) { // si hay un ID
      this.entidad.contactos = [];
      this.listadoContactos.setCargando(true);
      this.contactoService.getContactos(
        {
          page: null,
          pageSize: 50
        },
        {
          sort: 'nombre',
          order: 'asc'
        },
        {
          IdEntidad: IdEntidad
        }
      ).subscribe(
        respuesta => {
          if (respuesta.estado == 1 && respuesta.data && respuesta.data.contactos) {
            respuesta.data.contactos.forEach(contacto => {
              // console.log('Contacto', contacto);
              this.entidad.contactos.push(
                new Contacto(
                  contacto.apellido,
                  contacto.cargo,
                  contacto.celularCodigoPais,
                  contacto.celularCodigoArea,
                  contacto.celularNumero,
                  contacto.email,
                  <Entidad>{
                    IdEntidad: contacto.entidad.IdEntidad,
                    razonSocial: contacto.entidad.razonSocial
                  },
                  contacto.examen,
                  contacto.fechaAlta,
                  contacto.fechaCertificacion,
                  contacto.fechaModificacion,
                  contacto.ultimaModificacionPor,
                  contacto.dia_nacimiento,
                  contacto.mes_nacimiento,
                  contacto.fechaUltimaCertificacion,
                  contacto.idContacto,
                  contacto.interno,
                  contacto.kit,
                  contacto.nombre,
                  contacto.pago,
                  contacto.perfil,
                  contacto.razonSocial,
                  contacto.telefonoCodigoPais,
                  contacto.telefonoCodigoArea,
                  contacto.telefonoNumero,
                  <TipoContacto>{
                    IdTipoContacto: contacto.tipo.id,
                    tipoContactoDesc: contacto.tipo.desc
                  },
                )
              );
            });

            this.listadoContactos.setContactos(this.entidad.contactos);
          }

          this.listadoContactos.setCargando(false);
        },
        () => {
          this.listadoContactos.setCargando(false);
        }
      );
    }
  }

  onContactosChange() { // si cambia el listado de contactos
    this.entidad.contactos = this.listadoContactos.contactos; // actualizar contactos del entidad
    this.onInput();
  }
  onArchivoCargado(fileHolder: FileHolder): void {
    // this.subir = true;
    this.entidad.archivoEntidad.push(new ArchivoEntidad(
      fileHolder.src,
      fileHolder.file.name,
    ));

  }

  getEntidad(): Entidad {
    // revisar las validaciones
    /*
    if (this.razonSocialFormControl.hasError('required') ||
      this.cuitFormControl.hasError('required')) {
      // marcar inputs como usados para mostrar el error si es necesario
      this.razonSocialFormControl.markAsTouched();
      this.cuitFormControl.markAsTouched();

      throw "Datos incorrectos";
    }
    */
    if (this.razonSocialFormControl.hasError('required')) {
      // marcar inputs como usados para mostrar el error si es necesario
      this.razonSocialFormControl.markAsTouched();
      throw "Datos incorrectos";
    }

    if (this.emailFormControl.hasError('required')) {
      // marcar inputs como usados para mostrar el error si es necesario
      this.emailFormControl.markAsTouched();
      throw "Datos incorrectos";
    }
    /*if (this.entidad.contactos.length == 0) {
      throw "Debe ingresar al menos un contacto";
    } else {
      this.entidad.contactos.forEach((contacto: Contacto) => {
        if (!contacto.email || !contacto.email.trim()) {
          throw "Hay un contacto sin email, este campo es requerido";
        }
        if (!contacto.celular.area &&
          !contacto.celular.numero &&
          !contacto.celular.pais &&
          !contacto.telefono.area &&
          !contacto.telefono.numero &&
          !contacto.telefono.pais) {
          throw "Hay un contacto sin teléfono ni celular, ingrese al menos uno de estos dos campos";
        }
        if (!contacto.nombre) {
          throw "Hay un contacto sin nombre, este campo es requerido";
        }
        if (!contacto.tipoContacto.IdTipoContacto) {
          throw "Hay un contacto sin tipo, este campo es requerido";
        }
      });
    }*/


    return this.entidad;
  }

  traerPagos(): void {
    this.pagos = [];
    this.pagoService.getTiposPago(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta && respuesta.data && respuesta.estado == 1 && respuesta.data.pagos) {
          respuesta.data.pagos.forEach((pago) => {
            this.pagos.push(<TipoPago>{
              id: pago.id,
              descripcion: pago.descripcion
            });
          });
          // console.log('Tipos de Pago', this.pagos);

        }
      },
      () => {
      }
    );
  }

  validateFormat(event) {
    let key;
    if (event.type === 'paste') {
      key = event.clipboardData.getData('text/plain');
    } else {
      key = event.keyCode;
      key = String.fromCharCode(key);
    }
    const regex = /[0-9]|\./;
    if (!regex.test(key)) {
      event.returnValue = false;
      if (event.preventDefault) {
        event.preventDefault();
      }
    }
  }
}
